exports.components = {
  "component---src-templates-agenda-tsx": () => import("./../../../src/templates/agenda.tsx" /* webpackChunkName: "component---src-templates-agenda-tsx" */),
  "component---src-templates-homepage-tsx": () => import("./../../../src/templates/homepage.tsx" /* webpackChunkName: "component---src-templates-homepage-tsx" */),
  "component---src-templates-live-tsx": () => import("./../../../src/templates/live.tsx" /* webpackChunkName: "component---src-templates-live-tsx" */),
  "component---src-templates-tech-expo-tsx": () => import("./../../../src/templates/tech-expo.tsx" /* webpackChunkName: "component---src-templates-tech-expo-tsx" */)
}

